import theme from '@styles/theme';
import { FLUID_SECTION_HORIZONTAL_PADDING_CSS } from '@utils/fluidSectionHorizontalPadding';
import { ThemeUIStyleObject } from 'theme-ui';
type StylesType = {
  section: ThemeUIStyleObject;
  container: ThemeUIStyleObject;
  imageWrapper: ThemeUIStyleObject;
  image: ThemeUIStyleObject;
  contentWrapper: ThemeUIStyleObject;
  content: ThemeUIStyleObject;
  title: ThemeUIStyleObject;
  description: ThemeUIStyleObject;
  ctaButton: ThemeUIStyleObject;
};
const styles: StylesType = {
  section: {
    width: '100%',
    backgroundColor: theme.rawColors.neutralWhite,
    padding: FLUID_SECTION_HORIZONTAL_PADDING_CSS
  },
  container: {
    display: 'flex',
    flexDirection: ['column', 'column', 'row', 'row', 'row', 'row'],
    width: '100%',
    minHeight: ['auto', 'auto', '400px', '450px', '500px', '570px'],
    position: 'relative'
  },
  imageWrapper: {
    position: 'relative',
    width: ['100%', '100%', '50%', '50%', '50%', '50%'],
    minHeight: ['250px', '300px', '100%', '100%', '100%', '100%'],
    overflow: 'hidden'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  contentWrapper: {
    position: 'relative',
    width: ['100%', '100%', '50%', '50%', '50%', '50%'],
    backgroundColor: theme.rawColors.darkGrey400,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    padding: ['32px',
    // 32 + 105
    '108px 32px 32px',
    // 32 + 76
    '43px 76px 40px 40px',
    // 40 + 105
    '158px 100px 53px 53px',
    // 53 + 105
    '161px 150px 56px 56px',
    // 56 + 105
    '185px 200px 80px 80px' // 80 + 105
    ]
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    maxWidth: ['279px', '296px', '472px', '584px', '408px', '408px']
  },
  title: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    color: theme.rawColors.neutralWhite,
    fontSize: ['24px', '24px', '24px', '24px', '32px', '40px'],
    lineHeight: '96%',
    margin: 0,
    marginBottom: ['12px', '12px', '16px', '16px', '16px', '24px']
  },
  description: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    letterSpacing: ['1.4px', '1.4px', '1.4px', '1.4px', '1.6px', '1.6px'],
    color: theme.rawColors.neutralWhite,
    fontSize: ['14px', '14px', '14px', '14px', '16px', '16px'],
    lineHeight: '140%',
    margin: 0,
    marginBottom: ['16px', '16px', '24px', '24px', '24px', '32px'],
    whiteSpace: 'pre-wrap'
  },
  ctaButton: {
    display: 'inline-block',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    lineHeight: '140%',
    textTransform: 'lowercase',
    letterSpacing: '0.05em',
    padding: '10px 24px 9px',
    backgroundColor: theme.rawColors.neutralWhite,
    color: theme.rawColors.darkGrey700,
    border: 'none',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.rawColors.darkGrey700,
      borderColor: theme.rawColors.darkGrey700,
      color: theme.rawColors.neutralWhite
    }
  }
};
export default styles;